import {Component, OnInit} from '@angular/core';
import {TranslateService,LangChangeEvent} from '@ngx-translate/core';
import {FormGroup, FormControl, AbstractControl} from '@angular/forms';
import * as moment from 'moment';
import {UnitpriceService} from '../services/unitprice.service';
import {ChartConfigService} from '../services/chartconfig.service';
import { PrincipalService } from '../../../shared';
import {MaintenanceResourceService} from '../../../shared/services/maintenance-resource.service';
import * as jsPDF from 'jspdf';
import {Account} from "../../balance/types/account.type";
import { ROLE_CONSTANTS } from "../../../shared/constants/constant";

@Component({
  selector: 'app-unitprice',
  templateUrl: './unitprice.component.html',
  styleUrls: ['./unitprice.component.css']
})
export class UnitpriceComponent implements OnInit {

  public charts;
  public maxValueArray =[];
  public maxValue;
  public type;
  public progressIndicator = 'loading';
  public chosenTab;
  public chart;
  public unitData;
  public chartInfoData;
  public inMaintenance = false;
  public loadingIntervalPromise;
  public pickChosen;
  public chartParam = 1;
  public canvas;
  public dataURL;
  public initialRequest;
  public dataFound:boolean = false;
  public showCustomRange:boolean = false;
  public lang;
  public langSubscription;
  public updateStyle:boolean = false;
  public invalidDateRange:boolean = false;
  public buttonDisabled:boolean = false;
  public isDayDisabled:boolean = false;
  public clearSearch:boolean = true;
  public labelPeriodStart;
  public labelPeriodEnd;
  public customFundForm = new FormGroup({
    'searchString': new FormControl('')
  });
  public searchString:AbstractControl = this.customFundForm.get('searchString');

  public userRole;
  public account;
  public hideSearchString:boolean = false;

  constructor(private unitpriceService:UnitpriceService,
              public chartService:ChartConfigService,
              private maintenanceResourceService:MaintenanceResourceService,
              public translate:TranslateService,
              public principalService:PrincipalService) {
                    this.principalService.identity().then((account:Account) => {
                    this.account = account;
                    this.userRole = this.account.authorities[0];
                    if (this.userRole == ROLE_CONSTANTS.ROLE_EMPLOYER || this.userRole ==ROLE_CONSTANTS.ROLE_EMPLOYEE) {
                          this.searchString.patchValue('');
                          this.hideSearchString = false;
                    } else {
                          this.searchString.patchValue('');
                          this.hideSearchString = true;
                    }
                    });
                    this.lang = translate.currentLang;
                    this.langSubscription = this.translate.onLangChange.subscribe((event:LangChangeEvent) => {
                      this.lang = event.lang;
                      this.initialRequest = 1;
                      if (this.inMaintenance === false) {
                        if (this.chosenTab === '1WEEK') {
                          this.getChartData('1WEEK');
                        } else if (this.chosenTab === '1MONTH') {
                          this.getChartData('1MONTH');
                        } else if (this.chosenTab === '3MONTHS') {
                          this.getChartData('3MONTHS');
                        } else if (this.chosenTab === '6MONTHS') {
                          this.getChartData('6MONTHS');
                        } else if (this.chosenTab === '1YEAR') {
                          this.getChartData('1YEAR');
                        } else  {
                          this.getChartData('PERIOD');
                        }
                      }

                    });
                    this.unitpriceService.receive().subscribe(data => {
                      if(this.loadingIntervalPromise) {
                        clearInterval(this.loadingIntervalPromise);
                      }
                      if(data.length == 0){
                        this.progressIndicator = "nodata";
                      } else {
                        this.progressIndicator = "loaded";
                      }
                      this.onResponseReceived(data);
                    })

  }

  ngOnInit() {
    this.checkMaintenance();
    this.initialRequest = 0;
    this.getInitialData(this.initialRequest);
  }
  ngOnDestroy() {
    this.langSubscription.unsubscribe();
    clearInterval(this.loadingIntervalPromise);
  }
  public lineChartLabels:Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  public lineChartOptions = this.chartService.lineChartOptions;
  public lineChartColors = this.chartService.barChartColors;
  public lineChartLegend:boolean = false;
  public lineChartType:string = 'line';

  getInitialData(flag) {
    if(this.loadingIntervalPromise) {
      clearInterval(this.loadingIntervalPromise);
    }
    if (this.inMaintenance) {
      this.progressIndicator = "nodata";
      return;
    }
    this.progressIndicator = "loading";
    this.initResponseTimeoutHandler();
    this.initChartData();
    if(flag == 0){
      this.pickChosen = 1;
      this.unitpriceService.connect('1WEEK', this.lang,this.searchString.value);
      this.unitpriceService.subscribe();
    }
  }

  checkMaintenance() {
    this.inMaintenance = false;
    this.maintenanceResourceService.inMaintenance().toPromise().then(data => {
      this.inMaintenance = data;
      if (this.inMaintenance) {
        console.log('Currently system in maintenance, could not process unit price.');
      } else {
        this.getChartData("1WEEK")
      }
    }).catch(err => {
      this.inMaintenance = false;
    });
  }

  initChartData() {
    this.charts = [];
    this.maxValueArray = [1000];
  }

  initResponseTimeoutHandler() {
    this.loadingIntervalPromise = setInterval(() => {
      if (this.progressIndicator === "loading") {
        console.log('2 minutes waiting for unit price response is over.. Show timeout message!');
        this.progressIndicator = "timeout";
      }
    }, 120000);
  }

  getChartData(param) {
    if(this.loadingIntervalPromise) {
      clearInterval(this.loadingIntervalPromise);
    }
    this.initialRequest = 1;
    if (this.inMaintenance) {
      this.progressIndicator = "nodata";
      return;
    }
    this.progressIndicator = "loading";
    this.initResponseTimeoutHandler();
    this.initChartData();

    this.showCustomRange = false;
    if (param == '1WEEK') {
      this.chosenTab = '1WEEK';
      this.pickChosen = 1;
      this.unitpriceService.send1WeekRequest(this.lang,this.searchString.value);
    } else if (param == '1MONTH') {
      this.chosenTab = '1MONTH';
      this.pickChosen = 2
      this.unitpriceService.send1MonthRequest(this.lang,this.searchString.value);
    } else if (param == '3MONTHS') {
      this.chosenTab = '3MONTHS';
      this.pickChosen = 3;
      this.unitpriceService.send3MonthsRequest(this.lang,this.searchString.value);
    } else if (param == '6MONTHS') {
      this.chosenTab = '6MONTHS';
      this.pickChosen = 4;
      this.unitpriceService.send6MonthsRequest(this.lang,this.searchString.value);
    } else if (param == '1YEAR') {
      this.chosenTab = '1YEAR';
      this.pickChosen = 5;
      this.unitpriceService.send1YearRequest(this.lang,this.searchString.value);
    } else {
      this.progressIndicator = '';
      this.showCustomRange = true;
      this.chosenTab = 'PERIOD';
      this.pickChosen = 6;
    }
  }

  public requestPerformance() {
    let param = this.chosenTab;
    this.getChartData(param);
  }

  public onResponseReceived(data) {
    this.type = data['type'];
    if (this.chosenTab !== this.type) {
      return;
    }
    this.initChartData();
    this.charts = [];
    this.chart = {title: '', series: [], labels: [], data: []};
    this.unitData = data['funds'];
    if(data['endDate'].length != 0){
        this.labelPeriodEnd =  moment(data['endDate']).format('DD MMM YYYY');
    }
    if(data['startDate'].length != 0){
      this.labelPeriodStart = moment(data['startDate']).format('DD MMM YYYY');
    }
    if(data['funds'].length == 0){
      this.progressIndicator = "nodata";
    } else {
      for (var i = 0; i <= this.unitData.length; i++) {
        if (this.unitData[i] !== null && this.unitData[i] !== undefined) {
          this.chart = {series: [], labels: [], data: []};
          var chartData = [];
          this.chart.title = this.unitData[i].title;
          this.chartInfoData = this.unitData[i].data;
          for (var j = 0; j <= this.chartInfoData.length; j++) {
            if (this.chartInfoData[j] !== null && this.chartInfoData[j] !== undefined) {
              this.chart.labels.push(this.chartInfoData[j].label);
              chartData.push(this.chartInfoData[j].data);
              if (this.chartInfoData[j].data > this.maxValueArray[0]) {
                this.maxValueArray.push(this.chartInfoData[j].data);
              }
            }
          }
          this.chart.data.push(chartData);
          this.charts.push(this.chart);
        }
      }

      this.maxValue = Math.max.apply(Math, this.maxValueArray);
      this.maxValue = Math.round(this.maxValue);
      let temp = 0;
      while (temp < this.maxValue) {
        temp += 200;
      }
     /* console.log("afterincreemnt200+this.maxValue)")
      console.log(this.maxValue)*/
      this.maxValue = temp;
      console.log('Max Value === ' + this.maxValue);
      this.lineChartOptions = this.chartService.updateChartOptions(this.maxValue);
      if (this.charts.length > 0) {
        this.progressIndicator = "loaded";

      } else {
        this.progressIndicator = "nodata";
      }
      if (this.unitData.length == 0) {
        this.progressIndicator = "nodata";
      }
    }
  }

  exportToPdf() {
    var pdf = null;
    pdf = new jsPDF('p', 'mm');
    for (var i = 0; i <= this.charts.length; i++) {
      if (this.charts[i] !== null && this.charts[i] !== undefined) {
        var title = document.getElementById('chart-label-' + i);
        this.canvas = document.getElementById("chart-data-" + i);
        this.dataURL = this.canvas.toDataURL();

        var x = 20;
        var titleY = 20;
        var chartY = 20;


        var even = ((i + 1) % 2) === 0;
        if (even) {
          titleY = 165;
          chartY = 180;
        } else {
          chartY = chartY + 15;
        }
        pdf.text(x, titleY, this.charts[i].title);
        pdf.addImage(this.canvas.toDataURL(), 'JPEG', x, chartY);
        if (i < (this.charts.length - 1) && even) {
          pdf.addPage();
        }
      }
    }
    var filename = 'unit-price';
    if (this.chosenTab !== null || this.chosenTab !== undefined) {
      filename = filename + '-' + this.chosenTab.toLowerCase();
    }
    pdf.save(filename + '.pdf');
  }

  public getFormattedDate(date, flag) {
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    var day = date.getDate().toString();
    let neDateString;
    day = day.length > 1 ? day : '0' + day;
    if (flag == 1) {
      neDateString = year + '-' + month + '-' + '01';
    }
    if (flag == 2) {
      neDateString = year + '-' + month + '-' + '28';
    }
    return neDateString;
  }

  public getDateObject(date) {
    let mainDate = date.year + '-' + date.month + '-' + date.day;
    return mainDate;
  }

  clearSearchData() {
    this.searchString.patchValue('');
    this.clearSearch = false;
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  updateLabelStyle(){
    if(this.searchString.value != ''){
      this.updateStyle = true;
    } else {
      this.updateStyle = false;
    }
  }
}
